@if (isSearchVisible()) {
  <input
    #searchInput
    class="w-full border-b border-gray-400 bg-transparent text-sm font-semibold outline-none"
    [placeholder]="label()"
    [formControl]="control()"
    (click)="$event.stopPropagation()"
    (blur)="onBlur()" />
} @else {
  <div class="flex flex-row items-center gap-1">
    <span>{{ label() }}</span>
    <span
      class="material-symbols-rounded cursor-pointer text-base"
      [ngClass]="{ 'text-blue-500': control().value }"
      (click)="toggleSearch($event)">
      search
    </span>
  </div>
}
